function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
}

/**
 * Abre um PDF em modal com iframe (funciona em iOS Safari).
 * Antes abria em nova aba no mobile, mas blob URLs em novas abas falham no Safari iOS.
 */
export function openPdf(url, setPdfUrl, setShowPdfModal) {
  setPdfUrl(url)
  setShowPdfModal(true)
}

/**
 * Faz download de um PDF a partir de um blob URL.
 * - iOS Safari: usa navigator.share() com File API (abre o share sheet nativo)
 * - Outros: ancora com atributo download (comportamento padrão)
 */
export async function downloadPdf(blobUrl, filename) {
  if (isIOS() && navigator.canShare) {
    try {
      const response = await fetch(blobUrl)
      const blob = await response.blob()
      const file = new File([blob], filename, { type: 'application/pdf' })
      if (navigator.canShare({ files: [file] })) {
        await navigator.share({ files: [file], title: filename })
        return
      }
    } catch {
      // fallthrough para download padrão
    }
  }
  const a = document.createElement('a')
  a.href = blobUrl
  a.download = filename
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}
